module.exports = ".clr-control-container.clr-ng-select{width:100%}\n"